import { render, staticRenderFns } from "./Migalhas.vue?vue&type=template&id=7908b9bb&"
import script from "./Migalhas.vue?vue&type=script&lang=js&"
export * from "./Migalhas.vue?vue&type=script&lang=js&"
import style0 from "./Migalhas.vue?vue&type=style&index=0&id=7908b9bb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports